namespace GeniuzPOS.Common.Models {
    export interface IDCardResponse extends Serenity.ServiceResponse {
        Success?: boolean;
        Message?: string;
        CitizenID?: string;
        ThaiName?: string;
        EnglishName?: string;
        Address?: string;
        BirthDate?: string;
        ExpireDate?: string;
        HouseNo?: string;
        VillageNo?: string;
        Lane?: string;
        Road?: string;
        Tambol?: string;
        Amphur?: string;
        Province?: string;
        Sex?: string;
    }
}
